export const copyFilled = {
  name: "copy-filled" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-opacity=".84" d="M10 21h11V8H10v13Z"/><path fill-rule="evenodd" d="M2.1 3a.9.9 0 0 1 .9-.9h11.5a.9.9 0 0 1 .9.9v1.5a.9.9 0 0 1-1.8 0v-.6H3.9v12.7h2.6a.9.9 0 1 1 0 1.8H3a.9.9 0 0 1-.9-.9V3Zm7 5a.9.9 0 0 1 .9-.9h11a.9.9 0 0 1 .9.9v13a.9.9 0 0 1-.9.9H10a.9.9 0 0 1-.9-.9V8Zm1.8.9v11.2h9.2V8.9h-9.2Z" clip-rule="evenodd"/></svg>`,
  keywords: ["copy-filled"],
  category: "action" as const,
};
